import React from 'react';
import API from '../../services/API';
import CustomStore from 'devextreme/data/custom_store';
import useStyles from '../styles/styles';
import { Column, DataGrid, Paging, Editing } from 'devextreme-react/data-grid';
import usePermissions from '../../hooks/usePermissions';
import {
  BreadCrumbRender,
  onToolbarBreadCrumb,
  LoadPermissions,
} from '../../global';
import { Template } from 'devextreme-react/core/template';

const interestTypes = new CustomStore({
  key: 'InterestTypeId',
  load: async () => {
    const { data } = await API.sendRequest(`InterestType`, 'get');
    return data;
  },
  insert: async (data) => {
    await API.sendRequest(`InterestType`, 'post', data);
  },
  update: async (id, data) => {
    await API.sendRequest(`InterestType`, 'post', data);
  },
  remove: async (id) => {
    await API.sendRequest(`InterestType/${id}`, 'delete');
  },
});

const onRowUpdating = (options) => {
  options.newData = { ...options.oldData, ...options.newData };
};

const InterestType = () => {
  const classes = useStyles();

  /** *******************************
   * Access Control
   ******************************** */
  const ACL = usePermissions();
  while (ACL === undefined) {
    return <LoadPermissions>Loading permissions</LoadPermissions>;
  }
  if (ACL.NoAccess) {
    return (
      <LoadPermissions>You don't have access to this page</LoadPermissions>
    );
  }
  /** ****************************** */

  return (
    <div className={classes.divGridContainer}>
      <DataGrid
        id="gridContainer"
        dataSource={interestTypes}
        // keyExpr={'InterestTypeId'}
        allowColumnReordering
        showBorders
        onRowUpdating={onRowUpdating}
        rowAlternationEnabled
        showRowLines
        headerFilter={{ visible: true }}
        filterPanel={{ visible: true }}
        filterRow={{ visible: true }}
        onToolbarPreparing={onToolbarBreadCrumb}
      >
        <Paging enabled={false} />
        <Editing
          useIcons
          mode="form"
          allowAdding={ACL.AddNew}
          allowUpdating={ACL.Update}
          allowDeleting={ACL.Delete}
        />
        <Column dataField="InterestTypeDesc" caption="InterestType" />
        <Template name="breadCrumb" render={() => BreadCrumbRender(ACL)} />
      </DataGrid>
    </div>
  );
};

export default InterestType;
